import React, { useState, useRef, useEffect } from "react";
import { Button, Card } from "react-bootstrap";
import { ForwardOutlined, BackwardOutlined } from "@ant-design/icons";
import "./AudioPlayer.css";

const AudioPlayer = ({ src }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    const audioElement = audioRef.current;

    const handlePlay = () => {
      setIsPlaying(true);
    };

    const handlePause = () => {
      setIsPlaying(false);
    };

    if (audioElement) {
      audioElement.addEventListener("play", handlePlay);
      audioElement.addEventListener("pause", handlePause);
    }

    return () => {
      if (audioElement) {
        audioElement.removeEventListener("play", handlePlay);
        audioElement.removeEventListener("pause", handlePause);
      }
    };
  }, []);

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleForward = () => {
    if (audioRef.current) {
      audioRef.current.currentTime += 10;
    }
  };

  const handleBackward = () => {
    if (audioRef.current) {
      audioRef.current.currentTime -= 10;
    }
  };

  return (
    <Card className="audio-card p-3">
      <div className="audio-player-container">
        <audio
          ref={audioRef}
          src={src}
          controls
          controlsList="nodownload"
          className="audio-player"
        />
      </div>

      <div className="audio-controls mt-3">
        <Button variant="secondary" onClick={handleBackward}>
          <BackwardOutlined /> -10
        </Button>
        <Button variant="primary" onClick={togglePlayPause} className="ms-2">
          {isPlaying ? "Pause" : "Play"}
        </Button>
        <Button variant="secondary" onClick={handleForward} className="ms-2">
          <ForwardOutlined /> +10
        </Button>
      </div>
    </Card>
  );
};

export default AudioPlayer;
